import type { Role } from '@/features/auth/roles';

/**
 * Admin v2 shows the reminders bell to every role except Lab (#112) and
 * Mental health (#108), whose top bars have no bell.
 */
const NO_BELL: readonly Role[] = ['lab', 'mental_health'];

export function roleHasBell(role: Role): boolean {
  return !NO_BELL.includes(role);
}

/** "Larger text": every screen 15 % bigger for this person (#215). */
export const LARGER_TEXT_SCALE = 1.15;
